// extracted by mini-css-extract-plugin
export default {"vipLists":"vipLists_vipLists__glK0v","lists_title":"vipLists_lists_title__Xdf2+","lists_content":"vipLists_lists_content__HNnL9","lists_item":"vipLists_lists_item__8PB+7"};